import React, { Component } from 'react';
import PropTypes from 'prop-types';

import uniqueId from 'lodash/uniqueId';
import $ from 'jquery';

import SimpleModalWithHeader from './simple_modal_with_header.jsx';
import Button from './btn_basic.jsx';


class ConfirmSimpleModal extends Component {

  componentDidMount() {
    // do not close the modal on enter key click
    if (this.props.keepOpenOnReturn) {
      return;
    }

    this._uniqueId = uniqueId('confirm-modal-');

    $(document).on('keyup.' + this._uniqueId, (e)=> {
      if (e.keyCode === 13) {
        this.props.onConfirm();
      }
    });
  }

  componentWillUnmount() {
    // do not close the modal on enter key click
    if (this.props.keepOpenOnReturn) {
      return;
    }

    $(document).off('keyup.' + this._uniqueId);
  }

  render() {
    const { 
      className,
      alertType,
      title,
      body,
      confirmText,
      confirmButtonProps,
      cancelText,
      cancelButtonProps,
      confirmFooterExtra,
      onCancel,
      onConfirm,
      children,
      style,
      ...restProps
    } = this.props;

    const realTitle = title || (alertType === 'confirm' ? 'Are you sure?' : null);

    return (
      <SimpleModalWithHeader
        className={className}
        show={this.props.show} 
        onRequestClose={this.props.onCancel}
        closeOnOuterClick={this.props.closeOnOuterClick}
        style={style}
        title={realTitle}
        {...restProps}
      >
          <div>
            {body || children}
          </div>
          <div className="confirm-simple-modal-actions" style={{textAlign:'right', marginTop:'25px'}}>
            {confirmFooterExtra}
            { 
              alertType !== 'confirm' ? null :
              <Button 
                type="secondary"  
                onClick={onCancel} 
                {...cancelButtonProps}>
                  {cancelText}
              </Button>
            }
            <Button 
              style={{marginLeft:'10px'}} 
              onClick={onConfirm}
              {...confirmButtonProps}>
                {confirmText}
            </Button>
            <div className="clear"></div>
          </div>

      </SimpleModalWithHeader>
    );
  }
}


ConfirmSimpleModal.propTypes = {
  alertType: PropTypes.oneOf(['confirm','alert']),
  title: PropTypes.node,
  confirmText: PropTypes.node,
  confirmButtonProps: PropTypes.object,
  cancelText: PropTypes.node,
  cancelButtonProps: PropTypes.object,
  body: PropTypes.node,

  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,

  show: PropTypes.bool
};

ConfirmSimpleModal.defaultProps = {
  alertType: 'confirm',
  confirmText: 'OK',
  cancelText: 'Cancel',
  show: true,
  keepOpenOnReturn: false
};


export default ConfirmSimpleModal;
